// extracted by mini-css-extract-plugin
export default {"userInfoBox":"index__userInfoBox___brQQ6","kimImg":"index__kimImg___J2A5r","name":"index__name___dGpaZ"};